import { createIcon } from '@chakra-ui/react';

export const DocumentIcon = createIcon({
  displayName: 'DocumentIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    fill: 'none',
    height: '4',
    width: '4',
  },
  path: (
    <path
      d="M13.8965 2.25C14.1286 2.25002 14.3523 2.33072 14.5303 2.47656L14.6035 2.54297L18.457 6.39844C18.6445 6.58596 18.75 6.84034 18.75 7.10547V20.25C18.75 21.0784 18.0784 21.75 17.25 21.75H6.75C5.92157 21.75 5.25 21.0784 5.25 20.25V3.75C5.25 2.92157 5.92157 2.25 6.75 2.25H13.8965ZM6.75 20.25H17.25V8.75195H13.75C12.9216 8.75195 12.25 8.08038 12.25 7.25195V3.75H6.75V20.25ZM15.75 18.75H8.25V17.25H15.75V18.75ZM15.75 15.75H8.25V14.25H15.75V15.75ZM15.75 12.75H8.25V11.25H15.75V12.75ZM10.75 9.75H8.25V8.25H10.75V9.75ZM13.75 7.25195H17.1904L13.75 3.81055V7.25195Z"
      fill="currentColor"
    />
  ),
});
